import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, Link, useParams } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import '../../Css/resetRestaurant.css';
import { ResetRestaurant } from '../../Api/AuthRestaurant';
import Logo from '../../Image/logo.png';

const ResetPasswordRestaurant = () => {
    const [password, setPassword] = useState('');
    const [passwordC, setPasswordC] = useState('');
    const [showPass1, setShowPass1] = useState(false);
    const [showPass2, setShowPass2] = useState(false);
    const [loading, setLoading] = useState(false);



    let location = useLocation();
    let navigate = useNavigate();

    const { token } = useParams();


    const handlePassword1 = () => setShowPass1(!showPass1);
    const handlePassword2 = () => setShowPass2(!showPass2);


    const handleSubmit = (e) => {
        e.preventDefault();
        if (password !== passwordC) {
            toast.error("Le confirme mot de passe doit-être égal à mot de passe!");
        } else {
            setLoading(true);
            const data = { password: password };
            ResetRestaurant(token, data).then(function (response) {
                if (response.data.title === "success") {
                    navigate('/loginRestaurant');
                    toast.success(response.data.message);
                }
            }).catch(function (error) {
                console.log(error.response);
                if (error) {
                    toast.error(error.response.data.message);
                }
            }).finally(function () {
                setPassword("");
                setPasswordC("");
                setLoading(false);
            });
        }
    }
    return (
        <div>
            <Helmet>
                <title>Changement mot de passe ~ Restaurant </title>
                <meta name='description' content='Login client.' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='reset_restaurant'>
                {loading && <Loader />}
                <div className='col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 mx-auto layout_form'>

                    <div className='bloc_form'>
                        <div className='d-flex justify-content-center'>
                            <div className='login_logo'>
                                <img src={Logo} alt="logo e-kaly" />
                            </div>
                        </div>
                        <form onSubmit={handleSubmit} className='form_content'>
                            <h1 className="text-center">Changer votre mot de passe</h1>
                            <div className="mb-3 mt-4">
                                <div className='d-flex justify-content-start'>
                                    <label className="form-label">Nouveau mot de passe</label>
                                </div>
                                <input type={showPass1 ? "text" : "password"} className="form-control" required id="email" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Nouveau mot de passe ..." />
                            </div>
                            <div className='d-flex justify-content-end'>
                                <i className={showPass1 ? 'fa fa-eye-slash' : 'fa fa-eye'} onClick={handlePassword1} ></i>
                            </div>
                            <div className="mb-3">
                                <div className='d-flex justify-content-start'>
                                    <label className="form-label">Confirmer mot de passe</label>
                                </div>
                                <input type={showPass2 ? "text" : "password"} value={passwordC} required onChange={(e) => setPasswordC(e.target.value)} className="form-control" id="password" placeholder="Confirmer mot de passe ..." />
                            </div>
                            <div className='d-flex justify-content-end'>
                                <i className={showPass2 ? 'fa fa-eye-slash' : 'fa fa-eye'} onClick={handlePassword2} ></i>
                            </div>
                            <button type='submit' className='btn w-100'>Connexion</button>
                        </form>
                        <div className='d-flex justify-content-center'>
                            <Link to="/" className='retour'>
                                <span>Retour à la page d'accueil</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ResetPasswordRestaurant